import { json, useNavigate, useLoaderData } from "react-router-dom";
import { get, patch } from "../apiClient";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { Box, Button } from "@mui/material";
import useTitle from "../hooks/useTitle";
import { useScrollToTop } from "../hooks/useScrollToTop";
import PublisherStatusSection from "./../features/programmatic_supply/PublisherStatusSection";
import PublisherBiddersSection from "./../features/programmatic_supply/PublisherBiddersSection";
import PublisherCustomBidfloorSection from "./../features/programmatic_supply/PublisherCustomBidfloorSection";
import PublisherPlacementTargetingsSection from "./../features/programmatic_supply/PublisherPlacementTargetingsSection";

const loader = async ({ params, request }) => {
  try {
    const publisher = await get(
      "player",
      `/api/programmatic_supply/publishers/${params.id}`,
      { signal: request.signal }
    );

    return publisher;
  } catch (error) {
    throw json(
      {
        title: "There was an error fetching the publisher settings from the server",
        text: " Please try again. If the error is persistent, contact support.",
      },
      { status: error.status }
    );
  }
};

const splitList = (str) => str.length === 0 ? [] : str.split(",")

const action = async ({ params, request }) => {
  const formData = await request.formData();
  const { placement_ids, bidder_ids, ...payload } = Object.fromEntries(formData);

  try {
    const publisher = await patch(
      "player",
      `/api/programmatic_supply/publishers/${params.id}`,
      {
        ...payload,
        ...(placement_ids !== undefined && { placement_ids: splitList(placement_ids) }),
        ...(bidder_ids !== undefined && { bidder_ids: splitList(bidder_ids) }),
      },
      { signal: request.signal }
    );

    return publisher
  } catch (error) {
    switch(error.status) {
      case 400:
      case 422:
        return json(error.details, { status: error.status });
      default:
        /* istanbul ignore next */
        throw error;
    }
  }
}

const ProgrammaticSupplyPublisher = () => {
  const publisher = useLoaderData();
  const navigate = useNavigate();
  useTitle("Programmatic Supply Configuration > Publisher Configuration");
  useScrollToTop();

  return (
    <>
    <Box sx={{ display: "flex", flexDirection: "row", pb: 2 }}>
    <Button
    startIcon={<KeyboardArrowLeftIcon />}
    onClick={() => navigate("/programmatic_supply/publishers")}
    >
    Back
    </Button>
    </Box>
    <PublisherStatusSection publisher={publisher} />
    <PublisherCustomBidfloorSection publisher={publisher} />
    <PublisherBiddersSection publisher={publisher} />
    <PublisherPlacementTargetingsSection publisher={publisher} />
    </>
  );
};

export { loader, action };

export default ProgrammaticSupplyPublisher;
